import type IPressContact from '../../../models/press/press-contact.model';
import { ContactImageApiModel } from './contact-image.api-model';
import { TranslationApiModel } from './translation.api-model';

export class PressContactApiModel {
  public static mapToBusinessModel(apiModel: PressContactApiModel): IPressContact {
    return {
      id: apiModel.id,
      type: apiModel.type,
      name: apiModel.name,
      phoneNumber: apiModel.phonenumber,
      mobile: apiModel.mobile,
      email: apiModel.email,
      linkTwitter: apiModel.linkTwitter,
      image: apiModel.image ? ContactImageApiModel.mapToBusinessModel(apiModel.image) : undefined,
      title: apiModel.title ? TranslationApiModel.mapToBusinessModel(apiModel.title) : undefined,
      description: apiModel.description ? TranslationApiModel.mapToBusinessModel(apiModel.description) : undefined,
    };
  }

  public id!: string;
  public type!: string;
  public name!: string;
  public phonenumber!: string;
  public mobile!: string;
  public email!: string;
  public linkTwitter!: string;
  public image?: ContactImageApiModel;
  public title?: TranslationApiModel;
  public description?: TranslationApiModel;
}
